import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Flex,
  Icon,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Spinner,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MdAutoAwesome } from 'react-icons/md';
import { useSocket } from '../../Context/SocketContext';

const ClassGrid = ({ classes, filteredClass, isloading, setClasses }) => {
  const history = useHistory();
  const socket = useSocket();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const newClassInputRef = React.useRef();

  const [inputError, setInputError] = React.useState('');

  const handleSave = () => {
    if (!socket) return;

    const newClass = newClassInputRef.current.value;
    setInputError('');

    if (!newClass) {
      setInputError('Please enter a class name');
      setTimeout(() => {
        setInputError('');
      }, 3000);
      return;
    }

    if (classes.includes(newClass)) {
      setInputError('Class already exists');
      setTimeout(() => {
        setInputError('');
      }, 3000);
      return;
    }

    socket.emit('createClass', { courseName: newClass });

    setClasses(prev => [...prev, newClass]);
    onClose();
  };

  return (
    <Box color="#1B2559">
      {isloading && (
        <Flex justifyContent="center" mt="2rem">
          <Spinner
            thickness="4px"
            speed="0.8s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Flex>
      )}

      {!isloading && (
        <>
          <SimpleGrid minChildWidth="220px" spacing="40px" padding="10px">
            {filteredClass.map((className, index) => (
              <Flex
                key={index}
                height="96px"
                boxShadow="14px 17px 40px 4px rgba(112, 144, 176, 0.08)"
                borderRadius="10px"
                justifyContent="center"
                alignItems="center"
                cursor="pointer"
                onClick={() => history.push(`/classChat/${className}`)}
                bg="white"
              >
                <Flex
                  me="12px"
                  borderRadius="65px"
                  background="linear-gradient(180deg, #FBFBFF 0%, #CACAFF 100%)"
                  p="8px 14px"
                >
                  <Icon
                    as={MdAutoAwesome}
                    width="20px"
                    height="20px"
                    color="#422AFB"
                  />
                </Flex>
                <Text fontSize="18px" fontWeight="700">
                  {className}
                </Text>
              </Flex>
              // <ClassChatCard key={index} name={cls} />
            ))}
          </SimpleGrid>
          <Flex justifyContent="center" mt="3rem" mb="1rem">
            <Button
              border="1px solid #E2E8F0"
              p="0.7rem 1.2rem"
              borderRadius="45px"
              bg="white"
              cursor="pointer"
              onClick={onOpen}
            >
              <Text>Can't find your class?</Text>
            </Button>
            <Modal isOpen={isOpen} onClose={onClose}>
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>Create New Class</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  {inputError && (
                    <Alert status="error" h="45px" mb="10px">
                      <AlertIcon />
                      {inputError}
                    </Alert>
                  )}

                  <Input
                    isInvalid={inputError !== ''}
                    ref={newClassInputRef}
                    placeholder="Enter class name here ..."
                  ></Input>
                </ModalBody>

                <ModalFooter>
                  <Button
                    // isLoading={isloading}
                    loadingText="Adding"
                    colorScheme="blue"
                    mr={3}
                    onClick={handleSave}
                  >
                    Add
                  </Button>
                  <Button onClick={onClose}>Cancel</Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </Flex>
        </>
      )}
    </Box>
  );
};

export default ClassGrid;
